import { createApp } from "vue";

import App from "./App.vue";

import router from "./router";

import vuetify from "./plugins/vuetify";

import * as Sentry from "@sentry/vue";

import i18n from "./config/i18n";

import config from "@/config/env";

const app = createApp(App);

// Vue.use(VueI18n);

Sentry.init({
  app,
  ...config.sentry,
  autoSessionTracking: false,
  release: "bisom-web-bilan" + process.env.VUE_APP_VERSION,
  integrations: [Sentry.browserTracingIntegration()],
});

app.use(router).use(vuetify).use(i18n);

app.mount("#app");
